module.exports = __webpack_public_path__ + "static/default-university-thumbnail-e852d72af0e4b039b8cf5a9aaeedb9d8.png";